import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import TunnelButterFlyChart from '../chart/TunnelButterFlyChart';
import { EndPoint, StartPoint } from '../TunnelPoint';
import { useRecoilValue } from 'recoil';
import { tInfoUpdateState } from '../../atoms';
import SkeletonTable from '../SkeletonTable';
import GetFetchStatus from '../../hooks/GetFetchStatus';
import IssueGuide from '../IssueGuide';

const ExcavationProcessLarge = () => {
  const { t } = useTranslation();
  const isTunnelInfoUpdated = useRecoilValue(tInfoUpdateState);
  const { data, isError, refetch } = GetFetchStatus({ path: '/tarea' });

  useEffect(() => {
    refetch();
  }, [isTunnelInfoUpdated]);

  const onClickRefresh = () => refetch();

  if (isError) return <IssueGuide />;
  return (
    <div className='equipInfo excavationProcessLarge'>
      <div className='widget-header margin-top'>
        <div className='widget-title flex-between'>
          <span className='tunnel-title'>
            <span className='tunnel-name'>{t('굴진 진행 현황')}</span>
            <span className='tunnel-guide'>
              <StartPoint />
              <span className='seperator' />
              <EndPoint />
            </span>
          </span>
          <div className='refresh-btn' onClick={onClickRefresh} role='presentation'>
            <span className='material-symbols-rounded'>refresh</span>
          </div>
        </div>
      </div>
      {!data ? (
        <div style={{ width: '100%', height: '100%' }}>
          <SkeletonTable />
        </div>
      ) : (
        <TunnelButterFlyChart data={data.tareaList.map((tarea: TareaData, idx: number) => ({ ...tarea, no: idx + 1 }))} header={false} dashboard />
      )}
    </div>
  );
};

export default ExcavationProcessLarge;
